import React from 'react';
import { connect } from 'react-redux';
import {
  AppBar,
  Typography,
  Toolbar,
  IconButton,
  Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Menu } from '@material-ui/icons';
import logo from '../public/allot_logo.png';

const useStyles = makeStyles({
  root: {
    justifyContent: 'space-between',
  },
});

function Header({ isDrawerOpen, toggleDrawer, user }) {
  const classes = useStyles();
  return (
    <AppBar
      position="static"
      color=""
      style={{ minHeight: 80, justifyContent: 'center' }}
    >
      <Toolbar className={classes.root}>
        <Button>
          <img src={logo} />
        </Button>
        {user ? (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => toggleDrawer(!isDrawerOpen)}
          >
            <Menu />
          </IconButton>
        ) : null}
      </Toolbar>
    </AppBar>
  );
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps, null)(Header);



// WEBPACK FOOTER //
// ./src/Header.js